module.exports = __webpack_public_path__ + "img/1.ad2e1060.png";